import styled from 'styled-components';

const ListDiv = styled.div`
  padding: 8px;

  max-height: 300px;
  overflow-y: auto;
`;

const ListItem = styled.div`
  height: 32px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 8px;
  cursor: pointer;

  &:hover {
    background-color: var(--color-bg-input);
  }
`;

const ListElements = {
  ListDiv,
  ListItem,
};

export default ListElements;
